import { Package } from "lucide-react";
import type { PublicCategory, PublicProduct } from "@/types/store";
import styles from "./retail.module.css";

type Props = {
  categories: PublicCategory[];
  products: PublicProduct[];
  onCategory: (id: number) => void;
};

export default function RetailCategories({
  categories,
  products,
  onCategory,
}: Props) {
  if (!categories.length) return null;
  return (
    <section
      id="categorias"
      className={styles.categories}
      aria-label="Categorias"
    >
      <div className={styles.categoryGrid}>
        {categories.map((category) => {
          const product = products.find(
            (item) =>
              item.category === category.id &&
              (item.primary_image_url || item.images.length),
          );
          const image =
            product?.primary_image_url || product?.images[0]?.image_url;
          return (
            <a
              key={category.id}
              href="#catalogo"
              className={styles.categoryCard}
              onClick={() => onCategory(category.id)}
            >
              <div className={styles.categoryMedia}>
                {image ? (
                  <img src={image} alt="" loading="lazy" decoding="async" />
                ) : (
                  <Package size={34} strokeWidth={1} aria-hidden="true" />
                )}
              </div>
              <span>{category.name}</span>
            </a>
          );
        })}
      </div>
    </section>
  );
}
